export default __webpack_public_path__ + "static/media/add-box-icon.5353173e.svg";